import React from 'react'

const Love = (props) => (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5 0C8.45001 0 5.52494 1.2116 3.36828 3.36828C1.2116 5.52494 0 8.45001 0 11.5C0 14.5499 1.2116 17.4751 3.36828 19.6318C5.52494 21.7883 8.45001 23 11.5 23C14.5499 23 17.4751 21.7883 19.6318 19.6318C21.7883 17.4751 23 14.5499 23 11.5C23 8.45001 21.7883 5.52494 19.6318 3.36828C17.4751 1.2116 14.5499 0 11.5 0Z" fill="url(#love0)"/>
        <path d="M15.0552 5.75C11.8956 5.75 11.5003 8.372 11.5003 8.372C11.5003 8.372 11.1065 5.75 7.94684 5.75C4.90796 5.75 4.02246 8.94412 4.39334 10.6519C5.37084 15.1656 11.5003 18.3281 11.5003 18.3281C11.5003 18.3281 17.6312 15.1656 18.6087 10.6519C18.9782 8.94412 18.0912 5.75 15.0552 5.75Z" fill="white"/>
        <defs>
            <linearGradient id="love0" x1="11.5" y1="0" x2="11.5" y2="23" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FF6680"/>
                <stop offset="1" stopColor="#E61739"/>
            </linearGradient>
        </defs>
    </svg>
)

export default Love
